/*
 * HTTPリクエスト関連の定数を定義
*/

import ApiClient from '@/api/ApiClient'

export default class API {
  static baseUrl () {
    if (location.host.startsWith('localhost')) { // 開発環境
      return 'http://localhost:8080'
    } else { // QA環境
      return 'https://ec-model-cms.queue-inc.studio'
    }
  }

  static apiBaseUrl () {
    if (location.host.startsWith('localhost')) { // 開発環境
      return 'http://localhost:8080'
    } else { // QA環境
      return 'https://ec-model.queue-inc.studio'
    }
  }

  // API List
  // -> 引数にdata, paramsを記載すればアクセスができる(default: {})
  // Item系
  static GetItemList = ApiClient.apiExecutionFactory('/cms/item', 'get')
  static GetItemDetail = ApiClient.apiExecutionFactory('/cms/item/{item_id}', 'get')
  static AddItem = ApiClient.apiExecutionFactory('/cms/item', 'post')
  static UpdateItem = ApiClient.apiExecutionFactory('/cms/item', 'put')
  static TurnPublishItem = ApiClient.apiExecutionFactory('/cms/item/publish', 'put')
  static DeleteItem = ApiClient.apiExecutionFactory('/cms/item/delete', 'put')
  // Banner系
  static GetBannerList = ApiClient.apiExecutionFactory('/cms/banner', 'get')
  static AddBanner = ApiClient.apiExecutionFactory('/cms/banner', 'post')
  static UpdateBanner = ApiClient.apiExecutionFactory('/cms/banner', 'put')
  static DeleteBanner = ApiClient.apiExecutionFactory('/cms/banner', 'delete')
  // Category系
  static GetCategoryList = ApiClient.apiExecutionFactory('/cms/category', 'get')
  static AddCategory = ApiClient.apiExecutionFactory('/cms/category', 'post')
  static TurnPublishCategory = ApiClient.apiExecutionFactory('/cms/category', 'put')
  static DeleteCategory = ApiClient.apiExecutionFactory('/cms/category', 'delete')
  // Push系
  static GetPushList = ApiClient.apiExecutionFactory('/cms/push', 'get')
  static AddPush = ApiClient.apiExecutionFactory('/cms/push', 'post')
  static UpdatePush = ApiClient.apiExecutionFactory('/cms/push', 'put')
  static DeletePush = ApiClient.apiExecutionFactory('/cms/push', 'delete')
  // Producer系
  static GetProducerList = ApiClient.apiExecutionFactory('/cms/producer', 'get')
  static AddProducer = ApiClient.apiExecutionFactory('/cms/producer', 'post')
  static UpdateProducer = ApiClient.apiExecutionFactory('/cms/producer', 'put')
  static DeleteProducer = ApiClient.apiExecutionFactory('/cms/producer', 'delete')
  // Admin系
  static GetAdminUserList = ApiClient.apiExecutionFactory('/cms/admin', 'get')
  static AddAdminUser = ApiClient.apiExecutionFactory('/cms/admin', 'post')
  static ChangeAdminUserPassword = ApiClient.apiExecutionFactory('/cms/admin/password', 'post')
  // Cache更新
  static UpdateCache = ApiClient.apiExecutionFactory('/cache', 'get', this.apiBaseUrl())
}
